module.exports = __webpack_public_path__ + "img/bj_11.fdd78786.jpg";